import { PageContext } from './page-context';
import { ThemeContext } from './theme-context';
import type { IPageContext } from './page-context';
import type { PageDataType } from '../data';
import type { DeepReadonly } from 'ts-essentials';
import type {
    ICTTextListStyle,
    ICTTextBodyProperties,
    ICTTextCharacterProperties,
    ICTFontCollection,
    IEGColorChoice,
} from '@tencent/slide-sdk-pb-model';

export interface ITextBodyContext extends IPageContext {
    getListStyle?(): DeepReadonly<ICTTextListStyle> | undefined;
    getBodyPr?(): DeepReadonly<ICTTextBodyProperties> | undefined;
    getDefaultFont?(): DeepReadonly<Pick<ICTTextCharacterProperties, 'latin' | 'ea'>> | undefined;
    getDefaultTextFill?(): DeepReadonly<{ solidFill: { egColorChoice: DeepReadonly<IEGColorChoice> } }> | undefined;
}

export class TextBodyContext extends PageContext implements ITextBodyContext {
    public static fromPageContext(pageContext: Required<IPageContext>) {
        const context = new TextBodyContext(pageContext.getPageType());
        context.initContextFromPageContext(pageContext);
        return context;
    }

    private lstStyle?: DeepReadonly<ICTTextListStyle>;
    private bodyPr?: DeepReadonly<ICTTextBodyProperties>;
    private defaultFontCollection?: DeepReadonly<ICTFontCollection>;
    private defaultTextColor?: DeepReadonly<IEGColorChoice>;

    public constructor(pageType: PageDataType) {
        super(pageType);
    }

    public getListStyle(): DeepReadonly<ICTTextListStyle> | undefined {
        return this.lstStyle;
    }

    public getBodyPr(): DeepReadonly<ICTTextBodyProperties> | undefined {
        return this.bodyPr;
    }

    public getDefaultFont(): DeepReadonly<Pick<ICTTextCharacterProperties, 'latin' | 'ea'>> | undefined {
        return this.defaultFontCollection && ThemeContext.getFontStyleByFontCollection(this.defaultFontCollection);
    }

    public getDefaultTextFill(): { solidFill: { egColorChoice: DeepReadonly<IEGColorChoice> } } | undefined {
        return (
            this.defaultTextColor && {
                solidFill: {
                    egColorChoice: this.defaultTextColor,
                },
            }
        );
    }

    public setListStyle(lstStyle?: DeepReadonly<ICTTextListStyle>) {
        this.lstStyle = lstStyle;
    }

    public setBodyPr(bodyPr?: DeepReadonly<ICTTextBodyProperties>) {
        this.bodyPr = bodyPr;
    }

    public setDefaultFontCollection(fontCollection: DeepReadonly<ICTFontCollection>) {
        this.defaultFontCollection = fontCollection;
    }

    public setDefaultTextColor(color?: DeepReadonly<IEGColorChoice>) {
        this.defaultTextColor = color;
    }
}
